<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
     
      <div class="d-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Search "
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <vue-good-table :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <center>Aucune entrées correspondantes trouvées</center>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>
          <span v-else-if="props.column.field === 'type'">
            <div
              v-if="props.row.type == 'SIMPLE_PARCEL'"
              class="badge text-bg-warning fs-13 me-5 mt-10"
            >
              Colis Simple
            </div>
            <div
              v-if="props.row.type == 'SIMPLE_STOCK'"
              class="badge text-bg-info fs-13 me-5 mt-10"
            >
              Colis de stock
            </div>
          </span>

          <span v-else-if="props.column.field === 'statut'">
            <div
              :class="`fs-13 me-5 mt-10 badge text-bg-${resolveUStatus(0)}`"
              class="text-capitalize"
            >
              {{ props.row.statut }}
            </div>
          </span>
          <span v-else-if="props.column.field === 'customer'">
            <template v-if="props.row.magasin">
              {{ props.row.magasin.market_name }}
            </template>
            <template v-if="props.row.client?.store">
              <span v-if="props.row.magasin"> - </span>
              ({{ props.row.client.store }})
            </template>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent
        :pagination="users"
        :offset="9"
        @paginate="fetchData"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {  onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
export default {
  name: "PickupRequests",
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const headers = [
      {
        label: "Type",
        field: "type",
      },
      {
        label: "Store",
        field: "customer",
      },
      {
        label: "Remarques",
        field: "note",
      },
      {
        label: "Téléphone",
        field: "phone",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Adresse",
        field: "address",
      },
      {
        label: "Date d'ajout",
        field: "created_at",
      },
      {
        label: "Etat",
        field: "statut",
      },
    ];

    const rows = ref([]);
    const loading = ref(false);

    const users = reactive({
      searchCustomer: "",
      searchCity: "",
      searchStore: "",
      searchStatut: "",
      searchType: "",
      searchSDate: "",
      searchEDate: "",
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/pickup_request_list`, {
          params: {
            searchTerm: users.searchTerm,
            searchCity: users.searchCity,
            searchCustomer: users.searchCustomer,
            searchStore: users.searchStore,
            searchStatut: users.searchStatut,
            searchType: users.searchType,
            searchSDate: users.searchSDate,
            searchEDate: users.searchEDate,
            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    onMounted(async () => {
      fetchData();
    });

    function getDate(value: any) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }


    function resolveUStatus(status) {
      if (status === 0) return "primary";
      if (status === 1) return "info";
      if (status === 2) return "success";
      return "danger";
    }

    return {
      auth,
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      resolveUStatus,
    };
  },
};
</script>